// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Charge_searchMidle__ZSsAd {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
  margin: 4rem 0 1rem;
}
@media only screen and (max-width: 43.75em) {
  .Charge_searchMidle__ZSsAd {
    flex-direction: column;
    align-items: center;
  }
}

table tr {
  display: grid;
  grid-template-columns: 23% 23% 23% 23% 8%;
}

.Charge_option__XGwc\\+ {
  margin: 2rem 0;
}

.Charge_imageUpload__rFQwI {
  height: 15rem;
  width: 15rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Charge/Charge.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AADF;AAGE;EANF;IAOI,sBAAA;IACA,mBAAA;EAAF;AACF;;AAIE;EACE,aAAA;EACA,yCAAA;AADJ;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;AAFF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.searchMidle {\n  display: flex;\n  justify-content: flex-end;\n  gap: 2rem;\n  margin: 4rem 0 1rem;\n\n  @media only screen and (max-width: $bp-700) {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\ntable {\n  tr {\n    display: grid;\n    grid-template-columns: 23% 23% 23% 23% 8%;\n  }\n}\n\n.option {\n  margin: 2rem 0;\n}\n\n.imageUpload {\n  height: 15rem;\n  width: 15rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchMidle": `Charge_searchMidle__ZSsAd`,
	"option": `Charge_option__XGwc+`,
	"imageUpload": `Charge_imageUpload__rFQwI`
};
export default ___CSS_LOADER_EXPORT___;
